export default __webpack_public_path__ + "static/media/newrelic.d3209b78d6d5d5b904c7130003dd76ed.svg";